module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent",
    class: {
      isDisabled: _vm.isDisabled
    }
  }, [_c('div', {
    staticClass: "name"
  }, [(_vm.isDisabled) ? _c('div', [_vm._v(_vm._s(_vm.item.name))]) : _c('div', [(_vm.isLinkToItemDetail) ? _c('div', [_c('router-link', {
    attrs: {
      "target": "_blank",
      "to": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.item.name))])], 1) : _c('div', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$emit('clicked');
      }
    }
  }, [_vm._v(_vm._s(_vm.item.name))])])]), _vm._v(" "), (_vm.isObsolete) ? _c('div', {
    staticClass: "obsolete"
  }, [_c('span', [_vm._v("obsolete")])]) : _vm._e(), _vm._v(" "), (_vm.isCanceled) ? _c('div', {
    staticClass: "obsolete"
  }, [_c('span', [_vm._v("canceled")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ean"
  }, [_vm._v("EAN: " + _vm._s(_vm.item.clientEanRef))]), _vm._v(" "), _c('div', {
    staticClass: "sap"
  }, [_vm._v("SAP: " + _vm._s(_vm.item.clientSapRef))]), _vm._v(" "), (_vm.isShowPriceDetails) ? _c('div', {
    staticClass: "prices"
  }, [_vm._v("\n        Prices: "), _c('AllPricesInfo', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "item": _vm.item,
      "forecast-windows": _vm.forecastWindows
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a325532","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ItemDescription.vue
// module id = 3094
// module chunks = 0